// @flow
export const FEATURE_COMPARISON = [
  // 'gmv',
  'filters',
  'search',
  'visualMerchandising',
  'recommendation',
  'sellMore',
  'personalization',
  'analytics',
  'integration',
  'globalSales',
  'complimentaryFeatures',
  'infrastructureAndSupport'
];
// DATA TABLE OF LIST FEATURE PACKAGE COMPARISON
// Value is addon price with package
//            if value = 0 => auto applied
//            if value = -1 => not be applied
export const DATA_BY_FEATURE = {
  // gmv: [
  //   {
  //     content: 'AdminHTML.SubscriptionV5.PackageComparison.gmv',
  //     values: [
  //       'AdminHTML.SubscriptionV5.PackageComparison.gmv_Value01',
  //       'AdminHTML.SubscriptionV5.PackageComparison.gmv_Value02',
  //       'AdminHTML.SubscriptionV5.PackageComparison.gmv_Value03'
  //     ]
  //   }
  // ],
  filters: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature01',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature03',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature04',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature05',
      subtext: [],
      values: [5, 20, 'AdminHTML.SubscriptionV5.PackageComparison.unlimited']
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature06',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature07',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature08',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature09',
      subtext: [],
      values: [20, 40, 100]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.filters_Feature10',
      subtext: [],
      values: [0, 0, 0]
    }
  ],
  search: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature01',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature03',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature04',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature05',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature06',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature07',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature08',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature09',
      subtext: [],
      values: [20, 40, 100]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature10',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature11',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature12',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature13',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature14',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature15',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature16',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature17',
      subtext: [],
      values: [-1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature18',
      subtext: [],
      values: [0, 0, 0],
      isPremium: true
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature19',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature20',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature21',
      subtext: [],
      values: [0, 0, 0],
      isPremium: true
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.search_Feature22',
      subtext: [],
      values: [0, 0, 0],
      isPremium: true
    }
  ],
  visualMerchandising: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature00',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature06',
      subtext: [],
      values: [-1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature01',
      subtext: [],
      values: [10, 40, 100]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature03',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature04',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature05',
      subtext: [],
      values: [-1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature07',
      subtext: [],
      values: [-1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature08',
      subtext: [],
      values: [-1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.visualMerchandising_Feature09',
      subtext: [],
      values: [0, 0, 0]
    }
  ],
  recommendation: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature01',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature03',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature04',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature05',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature06',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature07',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature08',
      subtext: [],
      values: [0, 0, 0],
      isPremium: true
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature09',
      subtext: [],
      values: [0, 0, 0],
      isPremium: true
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature10',
      subtext: [],
      values: [0, 0, 0],
      isPremium: false
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature11',
      subtext: [],
      values: [0, 0, 0],
      isPremium: false
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature12',
      subtext: [],
      values: [0, 0, 0],
      isPremium: true
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature13',
      subtext: [],
      values: [0, 0, 0],
      isPremium: true
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature14',
      subtext: [],
      values: [-1, 0, 0],
      isPremium: false
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.recommendation_Feature15',
      subtext: [],
      values: [0, 0, 0],
      isPremium: false
    }
  ],
  sellMore: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.sellMore_Feature01',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.sellMore_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.sellMore_Feature03',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.sellMore_Feature04',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.sellMore_Feature05',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.sellMore_Feature06',
      subtext: [],
      values: [-1, 1000, 'AdminHTML.SubscriptionV5.PackageComparison.unlimited']
    }
  ],
  personalization: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.personalization_Feature01',
      subtext: [],
      values: [-1, -1, 0],
      isPremium: true
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.personalization_Feature02',
      subtext: [],
      values: [-1, -1, 0],
      isPremium: true
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.personalization_Feature03',
      subtext: [],
      values: [-1, -1, 0],
      isPremium: true
    }
  ],
  bundles: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.bundles_Feature01',
      values: [0, 0, 0],
      isPremium: false
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.bundles_Feature02',
      values: [0, 0, 0],
      isPremium: false
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.bundles_Feature03',
      isPremium: false,
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.bundles_Feature04',
      isPremium: false,
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.bundles_Feature05',
      isPremium: false,
      values: [-1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.bundles_Feature06',
      isPremium: false,
      values: [-1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.bundles_Feature07',
      isPremium: false,
      values: [0, 0, 0]
    }
  ],
  analytics: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature01',
      subtext: [],
      values: [
        'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature01_Value01',
        'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature01_Value02',
        'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature01_Value03'
      ]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature03',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature04',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature05',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature06',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature07',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.analytics_Feature08',
      subtext: [],
      values: [0, 0, 0]
    }
  ],
  integration: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.integration_Feature01',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.integration_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.integration_Feature03',
      subtext: [],
      values: [10, 40, 60]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.integration_Feature04',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.integration_Feature05',
      subtext: [],
      values: [0, 0, 0]
    }
  ],
  globalSales: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.globalSales_Feature01',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.globalSales_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.globalSales_Feature03',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.globalSales_Feature04',
      subtext: [],
      values: [-1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.globalSales_Feature05',
      subtext: [],
      values: [-1, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.globalSales_Feature06',
      subtext: [],
      values: [0, 0, 0]
    }
  ],
  complimentaryFeatures: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.complimentaryFeatures_Feature01',
      subtext: [],
      values: [-1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.complimentaryFeatures_Feature02',
      subtext: [],
      values: [20, 40, 100]
    }
  ],
  infrastructureAndSupport: [
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature01',
      subtext: [],
      values: [
        'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature01_Value01',
        'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature01_Value02',
        'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature01_Value03'
      ]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature02',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature03',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature04',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature05',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature06',
      subtext: [],
      values: [0, 0, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature07',
      subtext: [],
      values: [-1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature08',
      subtext: [],
      values: [-1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature09',
      subtext: [],
      values: [-1, -1, 0]
    },
    {
      content: 'AdminHTML.SubscriptionV5.PackageComparison.infrastructureAndSupport_Feature10',
      subtext: [],
      values: [-1, -1, 0]
    }
  ]
};
